import React from "react";
import "./BlogBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";
const BlogBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid blog-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/2.%20Travel%20Blog.webp"
            alt="Travel Blog"
            className="w-100"
            fetchpriority={useHighRes ? "high" : "auto"}
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
          />
          {imageLoaded ? (
            <>
              <div className="blog-text position-absolute text-white mt-xxl-5 pt-xxl-4 mt-md-2 mt-3">
                <p className="fs4 text-uppercase grotesk-headings">
                  Business Travel Revealed:
                </p>
                <HeadingH1 className="banner-headings">
                  Stories, Insights, <br /> and Updates
                </HeadingH1>
                <div className="d-flex common-second-content">
                  <div className="ornge-border"></div>
                  <div className="second-content">
                    Looking to reveal the secrets behind successful business
                    journeys? Dive into our collection of customer stories and
                    gain valuable tips to enhance your business adventure.
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default BlogBanner;
